

// import React, {
//   useMemo,
//   forwardRef,
//   useImperativeHandle,
//   useRef,
//   useState,
//   useEffect,
// } from "react";
// import PropTypes from "prop-types";
// import { Chart } from "react-chartjs-2";
// import MDBox from "components/MDBox";
// import CircularProgress from "@mui/material/CircularProgress";

// const ChartContainer = forwardRef(({ height, data, options, plugins }, ref) => {
//   const chartRef = useRef(null);
//   const [isDomReady, setIsDomReady] = useState(false);

//   useImperativeHandle(ref, () => ({
//     resetRevealAnimation: () => {
//       const chartInstance = chartRef.current;
//       if (chartInstance && chartInstance.resetRevealAnimation) {
//         chartInstance.resetRevealAnimation();
//       }
//     },
//   }));

//   // Wait until the next render tick to set DOM ready
//   useEffect(() => {
//     requestAnimationFrame(() => setIsDomReady(true));
//   }, [data, options, plugins]);

//   const chart = useMemo(() => {
//     if (!isDomReady) return null;
//     return (
//       <Chart
//         ref={chartRef}
//         type="line"
//         data={data}
//         options={options}
//         plugins={plugins}
//       />
//     );
//   }, [isDomReady, data, options, plugins]);

//   return (
//     <MDBox
//       sx={{
//         height: height || "400px",
//         width: "100%",
//         p: 2,
//         overflow: "hidden",
//         position: "relative",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       {!isDomReady && (
//         <CircularProgress size={40} thickness={4} />
//       )}
//       {chart}
//     </MDBox>
//   );
// });

// ChartContainer.propTypes = {
//   height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   data: PropTypes.object.isRequired,
//   options: PropTypes.object.isRequired,
//   plugins: PropTypes.array,
// };

// ChartContainer.defaultProps = {
//   height: "400px",
//   plugins: [],
// };

// export default ChartContainer;

// #########################################

import React, {
  useMemo,
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
  useEffect,
} from "react";
import PropTypes from "prop-types";
import { Chart } from "react-chartjs-2";
import MDBox from "components/MDBox";
import CircularProgress from "@mui/material/CircularProgress";

const ChartContainer = forwardRef(({ height, data, options, plugins }, ref) => {
  const chartRef = useRef(null);
  const [isDomReady, setIsDomReady] = useState(false);

  useImperativeHandle(ref, () => ({
    resetRevealAnimation: () => {
      const chartInstance = chartRef.current;
      if (chartInstance && chartInstance.resetRevealAnimation) {
        chartInstance.resetRevealAnimation();
      }
    },
  }));

  useEffect(() => {
    requestAnimationFrame(() => setIsDomReady(true));
  }, [data, options, plugins]);

  const chart = useMemo(() => {
    if (!isDomReady) return null;
    return (
      <Chart
        ref={chartRef}
        type="line"
        data={data}
        options={options}
        plugins={plugins}
      />
    );
  }, [isDomReady, data, options, plugins]);

  return (
    <MDBox
      sx={{
        height: height || "400px",
        width: "100%",
        p: 2,
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {!isDomReady && (
        <CircularProgress size={40} thickness={4} color="accent"/>
      )}
      {chart}
    </MDBox>
  );
});

ChartContainer.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  plugins: PropTypes.array, // ✅ Updated prop type
};

ChartContainer.defaultProps = {
  height: "400px",
  plugins: [],
};

export default ChartContainer;